var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84607 17.9453C2.50624 17.9453 2.23071 17.7092 2.23071 17.418V2.58213C2.23071 2.29091 2.50624 2.05479 2.84607 2.05479H12.0268L15.7685 5.26158V17.418C15.7685 17.7092 15.493 17.9453 15.1532 17.9453H2.84607ZM1 17.418C1 18.2917 1.82653 19 2.84607 19H15.1532C16.1727 19 16.9992 18.2917 16.9992 17.418V5.04316C16.9992 4.9033 16.9344 4.76918 16.819 4.67028L12.7168 1.15457C12.6014 1.05567 12.4449 1.00011 12.2817 1.00011H2.84607C1.82653 1.00011 1 1.70842 1 2.58213V17.418Z",
    fill: "#CC5A5A",
    stroke: "#CC5A5A",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8149 4.40819V2.74541L14.8563 4.40819H12.8149ZM11.5596 4.91943C11.5596 5.20178 11.8406 5.43066 12.1872 5.43066H16.3716C16.6255 5.43066 16.8544 5.3061 16.9515 5.11507C17.0487 4.92403 16.995 4.70414 16.8155 4.55793L12.6311 1.14967C12.4515 1.00346 12.1816 0.959721 11.947 1.03885C11.7125 1.11798 11.5596 1.3044 11.5596 1.51117V4.91943Z",
    fill: "#CC5A5A",
    stroke: "#CC5A5A",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5215 12.9293C6.6296 13.0873 6.82938 13.1846 7.04557 13.1846H10.955C11.1712 13.1846 11.371 13.0873 11.4791 12.9293C11.5872 12.7714 11.5872 12.5768 11.4791 12.4189L9.52438 9.5629C9.41628 9.40496 9.21651 9.30767 9.00031 9.30767C8.78411 9.30767 8.58433 9.40496 8.47624 9.5629L6.5215 12.4189C6.4134 12.5768 6.41341 12.7714 6.5215 12.9293ZM8.09371 12.1637L9.00031 10.8391L9.90691 12.1637H8.09371Z",
    fill: "#CC5A5A",
    stroke: "#CC5A5A",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00129 10.4155C9.21101 10.4155 9.40479 10.3124 9.50965 10.145L10.3848 8.74766C10.3848 8.74766 10.3848 8.74766 10.3848 8.74765C10.9997 7.76585 10.2311 6.53863 9.00129 6.53863C7.77149 6.53863 7.00288 7.76585 7.6178 8.74765C7.6178 8.74766 7.6178 8.74766 7.6178 8.74766L8.49293 10.145C8.59779 10.3124 8.79158 10.4155 9.00129 10.4155ZM9.00129 8.79217L8.63451 8.20654L8.63451 8.20653C8.47146 7.94621 8.67524 7.62086 9.00129 7.62086C9.32734 7.62086 9.53112 7.94621 9.36808 8.20653L9.36807 8.20654L9.00129 8.79217Z",
    fill: "#CC5A5A",
    stroke: "#CC5A5A",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3602 13.922C12.3602 13.922 12.3602 13.922 12.3602 13.922L11.9727 13.3714H12.7478C13.0922 13.3714 13.3075 13.6772 13.1353 13.922C12.9631 14.1667 12.5325 14.1667 12.3602 13.922ZM11.286 14.4308C11.9357 15.3538 13.5598 15.3538 14.2095 14.4307C14.8591 13.5077 14.0471 12.3538 12.7478 12.3538H10.8985C10.6769 12.3538 10.4722 12.4508 10.3614 12.6082C10.2506 12.7656 10.2506 12.9596 10.3614 13.117L11.286 14.4308Z",
    fill: "#CC5A5A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3602 13.922C12.3602 13.922 12.3602 13.922 12.3602 13.922ZM12.3602 13.922L11.9727 13.3714H12.7478C13.0922 13.3714 13.3075 13.6772 13.1353 13.922C12.9631 14.1667 12.5325 14.1667 12.3602 13.922ZM14.2095 14.4307C13.5598 15.3538 11.9357 15.3538 11.286 14.4308L10.3614 13.117C10.2506 12.9596 10.2506 12.7656 10.3614 12.6082C10.4722 12.4508 10.6769 12.3538 10.8985 12.3538H12.7478C14.0471 12.3538 14.8591 13.5077 14.2095 14.4307Z",
    stroke: "#CC5A5A",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78724 14.4307C4.4369 15.3538 6.06099 15.3538 6.71067 14.4308L6.71068 14.4307L7.63531 13.117C7.74609 12.9596 7.74609 12.7656 7.63531 12.6082C7.52452 12.4508 7.31978 12.3538 7.0982 12.3538H5.24892C3.94963 12.3538 3.1376 13.5077 3.78724 14.4307ZM5.63648 13.922C5.4642 14.1667 5.03365 14.1667 4.86144 13.922C4.6892 13.6772 4.90453 13.3714 5.24892 13.3714H6.024L5.63649 13.922C5.63649 13.922 5.63648 13.922 5.63648 13.922Z",
    fill: "#CC5A5A",
    stroke: "#CC5A5A",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintPdf);
export default __webpack_public_path__ + "static/media/print-pdf.1508027403804e9750222e904b4b6070.svg";
export { ForwardRef as ReactComponent };